import { defineStore } from "pinia";
import { useRoute } from "vue-router";
import { ref } from "vue";

export const useIsEmbeddedStore = defineStore("isEmbedded", () => {
    const route = useRoute();

    const isEmbedded = ref<boolean>(false);

    const initialize = () => {
        isEmbedded.value = route.query.isEmbedded === "true";
    };

    return {
        isEmbedded,
        initialize
    };
});